/**
 * Refresh the local session from the backend on navigation.
 *
 * The Pinia auth store is seeded from `localStorage['indiefy-user']`, so
 * subscription (and other) fields can lag behind Stripe/webhooks until
 * `GET api/user` runs. Call this from the router on every page so PRO
 * checks and account UI see the current server payload.
 *
 * Logged-out visits skip the request to avoid a 401 on public pages.
 * Magic-link arrivals (`?magic_link=1`) still refresh so a cookie-only
 * session can hydrate the store before `requiresAuth` runs.
 *
 * @param {Object} to - Vue Router target location
 * @param {Object} authStore - Pinia auth store
 * @returns {Promise<void>}
 */
export async function refreshSessionForNavigation(to, authStore) {
  if (!authStore?.isAuthenticated && to?.query?.magic_link !== '1') {
    return;
  }

  await authStore.verifySession();
}
